import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import A11y from 'chameleon/ui-stack/utilities/a11y';
import styles from './styles.css';
import Icon from 'chameleon/ui-stack/ui/base/icon';

const FirstLevelItem = (props) => {
  const { tag, className, item, children, onClick, isActive } = props;
  const NavTag = tag;
  const {
    id,
    label,
    iconName,
    to,
    children: itemChildren = [],
    notifIconTitle = '',
  } = item;

  const hasChildWithNotif = itemChildren.find(
    ({ showNotifIcon }) => showNotifIcon,
  );

  const _onClick = (event) => {
    onClick(event, id, to);
  };

  return (
    <NavTag className={cn(styles['first-level-item'], className)}>
      <A11y>
        <div
          aria-current={isActive ? 'page' : false}
          role="button"
          tabIndex={0}
          aria-labelledby={`label-${id}`}
          aria-controls={`items-container-${id}`}
          onClick={_onClick}
        >
          <div
            className={cn(
              'flex h-84 justify-center flex-col items-center outline-none',
              'text-white font-medium hover:bg-blue-700',
              'cursor-pointer text-center pl-1 pr-1',
              {
                [styles['first-level-item-active']]: isActive,
                'bg-blue-700': isActive,
              },
            )}
          >
            <Icon id={iconName} />
            <span id={`label-${id}`} className="relative text-sidebar w-min">
              {label}
              {hasChildWithNotif && (
                <Icon
                  accessibility={{ title: notifIconTitle }}
                  className="absolute text-red-600"
                  id="circle"
                />
              )}
            </span>
          </div>
        </div>
      </A11y>
      {children}
    </NavTag>
  );
};

FirstLevelItem.propTypes = {
  className: PropTypes.string,
  tag: PropTypes.string,
  onClick: PropTypes.func,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  isActive: PropTypes.bool,
  isExpanded: PropTypes.bool,
};

FirstLevelItem.defaultProps = {
  className: '',
  tag: 'li',
  onClick: () => {},
  isActive: false,
  isExpanded: false,
};

export default FirstLevelItem;
